<template>

  <ion-page id="big-button-menu-page">
    <ion-content>
      <div id="page" :class="{ 'text-dark' : isDark,'text-light' : !isDark }" :style="styleOneFrame" :key="menuTrigger">
        <div style="display: inline;" v-for="item in displayMenuItems" v-bind:key="item.index">
          <ion-button :disabled="item.disabled" :class="{'general-big-button' : true,
                                'button-color' : true,
                               'landscape-menu-button' : !isPortrait,
                               'portrait-menu-button' : isPortrait}"
           @click="buttonClicked(item)">
            <ion-label>
              <h1>{{ item.title }}</h1>
              <p class="smaller-font">{{ item.second }}</p>
            </ion-label>
          </ion-button>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

  import { IonItem, IonLabel, IonList, IonButton, IonRange,IonPage, IonContent, modalController } from '@ionic/vue';
  import { t } from '@/composables/translateText.js'

  import { availableWidthHeight }  from '@/composables/screenSize'

  import { doStartupCheck } from '@/composables/startupCheck.js'

  import { ref, watch , onMounted} from 'vue'

  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  const emit = defineEmits(['menu-item-click','menu-help-item-click'])

  const props = defineProps({
    whichMenu : {
      type : String,
      default : "mainMenu"
    }
  })

  const isPortrait = ref(window.innerWidth <= window.innerHeight)

  const connectionStore = useConnectionStore()

  const whichBigMenu = connectionStore.getWhichBigButtonMenu

  const deviceType = connectionStore.getDeviceType

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)
  const isSubscriber = connectionStore.getIsSubscriber
  const freeSubscriberString = "(" + ((isSubscriber == 1) ? t("Subscriber") : t("Free")) + ")"
  const openGameId = connectionStore.getPlayComputerGameId
  const versionID = connectionStore.versionID

  const subscribeString = (connectionStore.getSubscriberExpireDisplayString != "") ? 
                          t("Subscriber") + ": " + connectionStore.getSubscriberExpireDisplayString :
                          t("Subscribe")

  const isWeb = (deviceType != "ios" && deviceType != "android")
  const lichessAccessToken = connectionStore.getLichessAccessToken

  const mainMenuItems = [
    { index: 0,title : t("Play Computer"), program: "play_computer", second : freeSubscriberString, disabled:false },
    { index: 1,title : t("Play Blindfold"), program: "play_blindfold", second : freeSubscriberString, disabled:false },
    { index: 2,title : t("Continue Game?"), program: "play_continue", second : "", disabled:(openGameId == "0") },
    { index: 3,title : t("Puzzles"), program: "puzzles", second : "", disabled:false},
    { index: 4,title : t("Lichess Menu"), program: "lichess_menu", second : t("Web Only"), disabled:!isWeb},
    { index: 5,title : t("Account Menu"), program: "account_menu", second : "", disabled:false},
    { index: 6,title : t("Big Button & EyeGaze Preferences"), program: "big_button_preferences", second : "", disabled:false },
    { index: 7,title : t("Board & Language Preferences"), program: "preferences", second : "", disabled:false },
  ]

   const lichessMenuItems = [
    { index: 0,title : t("'Rapid' Pairing"), program: "lichess_rapid_challenge", second : "", disabled:lichessAccessToken == "" },
    { index: 1,title : t("'Correspondence' Pairing"), program: "lichess_correspondence_challenge", second : "", disabled:lichessAccessToken == "" },
    { index: 2,title : t("Challenge Friend"), program: "lichess_friend", second : "", disabled:lichessAccessToken == "" },
    { index: 3,title : t("Arena Tournaments"), program: "lichess_arena", second : "", disabled:lichessAccessToken == ""},
    { index: 4,title : t("Open Game List"), program: "lichess_open_gamelist", second : "", disabled:lichessAccessToken == ""},
    //{ index: 5,title : t("BOT Challenge"), program: "lichess_bot_challenge", second : "", disabled:lichessAccessToken == ""},
  ]

    const aiGameMenuItems = [
    { index: 0,title : t("Lichess"), program: "play_computer", second : "", disabled:false },
    { index: 1,title : t("Chess.com"), program: "play_blindfold", second : "", disabled:false },
    { index: 2,title : t("Import PGN"), program: "play_continue", second : "", disabled:false },
    { index: 3,title : t("Paste PGN"), program: "puzzles", second : "", disabled:false},
    { index: 4,title : t("Account"), program: "lichess_menu", second : "", disabled:false},
    { index: 5,title : t("Account Menu"), program: "account_menu", second : "", disabled:false},
    { index: 6,title : t("Big Button & EyeGaze Preferences"), program: "big_button_preferences", second : "", disabled:false },
    { index: 7,title : t("Board & Language Preferences"), program: "preferences", second : "", disabled:false },
  ]

  if (lichessAccessToken == "")
    lichessMenuItems.push({ index:6 ,title : t("Connect to Lichess"), program: "lichess_connect", second : t("Do First"), disabled:false })
  else
    lichessMenuItems.push({ index: 6,title : t("Disconnect"), program: "lichess_disconnect", second : "", disabled:false })
  lichessMenuItems.push({ index: 7,title : t("Main Menu"), program: "main_menu", second : "", disabled:false })

   const accountMenuItems = [
    { index: 0,title : t("Signin"), program: "signin", second : "", disabled: connectionStore.getDummy == 0},
    { index: 1,title : t("Register"), program: "register", second : "", disabled:connectionStore.getDummy == 0 },
    { index: 2,title : t("Signoff"), program: "signoff", second : "", disabled:connectionStore.getDummy != 0 },
    { index: 3,title : subscribeString, program: "subscribe_blurb", second : "", disabled:false },
    { index: 4,title : t("Cancel Subscription"), program: "cancel_subscription", second : "", disabled:false },
    { index: 5,title : t("Main Menu"), program: "main_menu", second : "", disabled:false },
    { index: 6,title : "Chessvis V" + versionID, program: "main_menu", second : "(c) 2025, Conceptual Software, Inc.", disabled:true }
  ]

  const displayMenuItems = ref( (props.whichMenu == "mainMenu") ? mainMenuItems : aiGameMenuItems)
  if (whichBigMenu == "lichess")
    displayMenuItems.value = lichessMenuItems
  else
  if (whichBigMenu == "account")
    displayMenuItems.value = accountMenuItems

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const styleOneFrame = ref({
     position : "absolute",
     "overflow-y" : "scroll",
     top : "0px",
     left : "100px",
     width: "100px",
     height : "100px"
   })

  function afterStartupCallbackRoutine(stuffChanged) {
    if (connectionStore.getIsSubscriber != 1) {
      return
    }
    menuTrigger.value++
  }

  updateWidthHeights()

  doStartupCheck(false,afterStartupCallbackRoutine)

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** Explorer -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** Explorer new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })

  function updateWidthHeights() {
  
    isPortrait.value = window.innerWidth <= window.innerHeight

    const availableSpace = availableWidthHeight()

    // don't need room for the toolbar
    const whichMenu = localStorage.getItem("whichMenu")
    const showBigButtons = whichMenu == "buttons" || connectionStore.getShowBigButtons
    var footerHeight = connectionStore.getToolbarHeight
    if (showBigButtons)
      footerHeight = Math.floor(footerHeight * connectionStore.getToolbarScalePercentage / 100.0)

    const oneframePositionTop = availableSpace.topIndent
    const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent + footerHeight
    const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    styleOneFrame.value.height = oneframeHeight + "px"
    styleOneFrame.value.width = oneframeWidth + "px"
    styleOneFrame.value.top = oneframePositionTop + "px"
    styleOneFrame.value.left = oneframePositionLeft + "px"


  }
  
  function buttonClicked(item) {
    //console.log("Selected",item.program,item.title)

    if (item.program == "lichess_menu") {
      connectionStore.setWhichBigButtonMenu("lichess")
      displayMenuItems.value = lichessMenuItems
    }
    else
    if (item.program == "account_menu") {
      connectionStore.setWhichBigButtonMenu("account")
      displayMenuItems.value = accountMenuItems
    }
    else
    if (item.program == "main_menu") {
      connectionStore.setWhichBigButtonMenu("main")
      displayMenuItems.value = mainMenuItems
    }
    else
      emit("menu-item-click",item.program,item.title,"buttons")

  }

  onMounted(() => {
    var element = document.getElementById("page")
    if (element != null)
      element.style.setProperty("--radio_button_size", 200 + "px");
  })
</script>

<style scoped>

#page {
  --done_button_size : 150px;
}

.font {
  font-size : 20px;
  line-height : 1.2em;
}

.smaller-font {
  font-size : 16px;
  line-height : 1.2em;
  font-style: italic;
  color : white;
}

.landscape-menu-button {
  width : 24%;
  height: 48%;
  margin-left : .4%;
  margin-right : .4%;
  margin-top : .4%;
  margin-bottom : .4%;
}



.portrait-menu-button {
  --background: teal;       /* Teal background */
  width : 48%;
  height: 24%;
  margin-left : .4%;
  margin-right : .4%;
  margin-top : .4%;
  margin-bottom : .4%;
}

.button-color {
  --background: maroon;       /* Teal background */
}

.button-color:hover {
  --background : #993232;
}
</style>
